import React from 'react';
import { bool, elementType, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { square } from '../../internals/utils/stylesHelpers';
const BaseIcon = _ref => {
  let {
    className,
    element,
    isVisible
  } = _ref;
  const StyledElement = styled(element)(_ref2 => {
    let {
      theme: {
        palette,
        spacing,
        transitions
      }
    } = _ref2;
    return {
      pointerEvents: 'none',
      color: palette.primary.contrastText,
      opacity: 0,
      position: 'absolute',
      transition: "all ".concat(transitions.duration.short, "ms"),
      ...square(spacing(3)),
      '& path': {
        fill: palette.primary.contrastText
      },
      '&.sovosNavigation__productIcon--visible': {
        opacity: 1
      }
    };
  });
  return /*#__PURE__*/React.createElement(StyledElement, {
    className: clsx(className, 'sovosNavigation__productIcon', isVisible && 'sovosNavigation__productIcon--visible')
  });
};
BaseIcon.propTypes = {
  className: string,
  element: elementType.isRequired,
  isVisible: bool.isRequired
};
export default BaseIcon;